module.exports = __webpack_public_path__ + "img/logo.ec0d7986.png";